import React, { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import * as S from './styles'
import { Table, UnidataTable, Modal } from '~/components'
import { TableSearchListdDef } from '~/componentslocal'
import RateioComponent from './RateioComponent';

import { number } from '~/helpers';

import moment from 'moment';
import api from '~/services/api';
import { format, parseISO } from 'date-fns';
import { isEmpty, isEqual } from 'lodash';
import { toast } from 'react-toastify';
import { t } from '~/helpers';

import { Button } from '@material-ui/core';
import usuario from '~/store/modules/usuario/reducer';

import {
    recordFiltering,
    dataInRequest
} from '~/store/modules/rateio/actions';

import { resetParams } from '~/store/modules/hooks/actions'



export default function Rateio() {

    const dispatch = useDispatch();
    const modalRef = useRef(null)

    const [loadingModalRequest, setLoadingModalRequest] = useState(false);
    const [productData, setProductData] = useState([])
    const [isGppe, setIsGppe] = useState(false)
    const [selectedProduct, setSelectedProduct] = useState({})
    const [query, setQuery] = useState({})

    const data = useSelector((state) => state.rateio)

    const user = useSelector((state) => state.user)

    async function handleGetProducts() {
        const resp = await api.get('rateio');
        if (resp.data.items.length > 0) {
            setProductData(resp.data.items)
            setSelectedProduct({})
        }
    }


    useEffect(() => {
        handleGetProducts();
    }, [])

    useEffect(() => {
        if (user.usuarioacesso.perf_codigo == 5) {
            setIsGppe(true)
        }
    }, [user])

    const actionsModal = useMemo(() => [
        {
            label: t('s.geral.botaoconfirmar'),
            callback: () => handleExecuteRateio({ data: data, product: selectedProduct }),
            color: 'primary',
            autoFocus: true,
        },
        {
            label: t('s.geral.botaofechar'),
            callback: () => modalRef.current.handleCloseModal(),
            color: 'secondary',
        },
    ], [selectedProduct, data])

    const handleSelectProduct = useCallback(async (value) => {

        let tempQuery = {
            wherefield: ['prod_codigo'],
            valuewherefield: [value.prod_codigo],
            typewherefield: ['EQUALS'],
            page: 1,
            pagesize: 99999,
        }

        if (isEmpty(query)) {
            setQuery(tempQuery)
        } else if (!isEqual(query, tempQuery)) {
            await dispatch(recordFiltering(tempQuery))
            setQuery(tempQuery)
        }

        setSelectedProduct(value)
    }, [query])


    const validateVolume = useCallback((rows) => {
        let isValid = true;
        rows.every((item) => {
            if ((Number(item.esop_saldo) + Number(item.volume_perda_sobra)) < 0) {
                isValid = false;
                return false;

            }
            return true;
        })

        return isValid
    }, [])

    const handleExecuteRateio = useCallback(async ({ data, product }) => {
        try {
            setLoadingModalRequest(true)

            if (data.data.length < 1) {
                toast.error('Nehum órgão disponível para a realização do rateio !')
                setLoadingModalRequest(false)
            } else if (validateVolume(data.data)) {

                await api.put(`rateio/${product.prod_codigo}`);
                dispatch(resetParams())
                handleGetProducts();
                setLoadingModalRequest(false)
                modalRef.current.handleCloseModal()

            } else {
                setLoadingModalRequest(false)
                toast.error('Verifique se todos os órgãos possuem saldo suficiente para realização do rateio!')
            }

        } catch (erros) {
            setLoadingModalRequest(false)
            erros.map((error) => toast.error(error));
        }
    }, [])

    const productHeading = useMemo(() => [
        { id: 'prod_codigo', label: 'Cód. Produto' },
        { id: 'prod_descricao', label: 'Nome Produto' },
        { id: 'peso_volume',
          label: 'Volume' ,          
          align: 'right',
          format: (value) => number(value, 1),
        },    
        {
            id: 'peso_ult_atualizacao',
            label: 'Última atualização',
            format: (value) => moment(value).format('DD/MM/YYYY HH:mm')
        },
    ], [])

    const header = useMemo(() => [
        {
            id: 'orga_codigo',
            label: 'Órgão Código',
            filter: { type: 'text' },
        },
        {
            id: 'orga_nome',
            label: 'Nome do Órgão',
            filter: { type: 'text' },
        },
        {
            id: 'esop_saldo',
            label: 'Saldo',
            //formatted: (value) => value.toFixed(1),
            //filter: { type: 'text' },
            align: 'right',
            formatted: (value) => number(value, 1),
        },
        {
            id: 'percentual_perda_sobra',
            label: '% Participação nos abastecimentos',
            //filter: { type: 'text' },
            //filter: { type: 'text' },
            align: 'right',
            formatted: (value) => number(value, 3),
        },
        {
            id: 'volume_perda_sobra',
            label: 'Rateio',
            //filter: { type: 'text' },
            //filter: { type: 'text' },
            align: 'right',
            formatted: (value) => number(value, 3),
        },
    ],
        [])



    return (
        <S.Wrapper>
            <S.ButtonWrapper>
                <Button
                    color="primary"
                    size="small"
                    variant="contained"
                    disabled={!isGppe || isEmpty(selectedProduct)}
                    onClick={() => modalRef.current.handleOpenModal()}>
                    Executar rotina de rateio
                </Button>
            </S.ButtonWrapper>

            <TableSearchListdDef
                cells={productHeading}
                data={productData}
                loading={false}
                size="small"
                unique="prod_codigo"
                onRow={(value) => handleSelectProduct(value)}
            />
            {!isEmpty(selectedProduct) && <UnidataTable
                maxHeight="45vh"
                reportOrder="orga_nome ASC"
                fixed
                read={dataInRequest}
                redux={data}
                header={header}
                query={query}
                detach="orga_nome"
                keys="orga_codigo"
                create={false}
                update={false}
                delete={false}
                title={selectedProduct.prod_descricao}

            />}

            <Modal
                disableBackdropClick
                disableEscapeKeyDown
                ref={modalRef}
                maxWidth="xs"
                title="Confirmação rateio"
                component={() => <RateioComponent product={selectedProduct} />}
                actions={actionsModal}
                loading={loadingModalRequest}
            />

        </S.Wrapper>)
}